import logo from "./logo.svg";
import "./App.css";
import img from "./Images/Tiwi-log.png";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Faq from "./components/FaqPage/Faq";
import PrivacyPolicy from "./components/PrivacyPage/Privacy";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Faq />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        </Routes>
      </BrowserRouter>
    </>
  );
}
export default App;
